import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.75 3C2.50736 3 1.5 4.00736 1.5 5.25V6.75H16.5V5.24981C16.5 4.00705 15.4925 3 14.25 3H3.75Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 12.75V8.25H16.5V12.75C16.5 13.9926 15.4926 15 14.25 15H3.75C2.50736 15 1.5 13.9926 1.5 12.75ZM5.25 9.75C4.83579 9.75 4.5 10.0858 4.5 10.5C4.5 10.9142 4.83579 11.25 5.25 11.25H7.5C7.91421 11.25 8.25 10.9142 8.25 10.5C8.25 10.0858 7.91421 9.75 7.5 9.75H5.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }